import React, { useEffect, useState } from "react";
import { Button, Grid, IconButton, Tooltip, CircularProgress } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import MUIDataTable from "mui-datatables";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import PConfirm from "../../../components/pos/PConfirm";
import { SyncUtils } from "../../../utils/SyncUtils";
import db from "../../../db/db";
import PDatePicker from "../../../components/pos/PDatePicker";
import API from "../../../utils/API";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function ProductionCrud(props) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [prodLookupValue, setProdLookupValue] = useState();
  const [items, setItems] = useState([]);
  const [liveValidation, setLiveValidation] = useState(false);
  const [windowTitle, setWindowtitle] = useState("");

  const [productionNumber, setProductionNumber] = useState();
  const [productionNumberError, setproductionNumberError] = useState();
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState();
  const [productionDate, setProductionDate] = useState("");
  const [productionDateError, setProductionDateError] = useState();

  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [origObject, setOrigObject] = useState();
  const { t } = useTranslation();
  const translate = t;

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  useEffect(() => {
    if (props.selectedProduction) {
      populateProduction(props.selectedProduction);
    }
  }, [props.selectedProduction]);

  useEffect(() => {
    if (props.mode === "create") {
      setWindowtitle(translate("Production Stock Update"));
    }
    let d = new Date();
    d.setHours(d.getHours());
    d.setMinutes(d.getMinutes());
    d.setSeconds(d.getSeconds());
    setProductionDate(d.toISOString());
  }, []);

  useEffect(() => {
    if (origObject) {
      setWindowtitle(origObject.productionNumber);
    }
  }, [origObject]);

  const REST_API_PAYLOAD_LIMIT = 5;

  async function populateProduction(productionId) {
    let { data } = await API.get("/api/v1/production/" + productionId);
    setOrigObject(data);
    setProductionNumber(data.productionNumber);
    setDescription(data.description);
    setProductionDate(data.productionDate);
    let items = [];
    let count = 1;
    for (let dbItem of data.productionItems) {
      let prodBean = await db.product.get(dbItem.productId);
      let item = [
        { v: count },
        { v: dbItem.productName },
        { v: dbItem.batchNumber }, //batchnumber
        //{ v: pricingBean.cost },
        //{ v: null }, //newcost
        { v: dbItem.unitType },
        { v: dbItem.quantity }, //quantity
        {
          info: {
            productBean: prodBean,
          },
        },
      ];
      items.push(item);
      count++;
    }
    setItems(items);
  }

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function getOptionsAsync(inputValue, callback) {
    let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100,
      ["P"],
      false,
      false,
      1
    );
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );
    //return callback([]);
  }

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      addProductToTable(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  async function addProductToTable(productBean, pricingBean) {
    var data = [...items];
    let itemIndex = getItemIndex(productBean.id, data);
    if (itemIndex == null) {
      let sn = data.length + 1;
      let item = [
        { v: sn },
        { v: productBean.name },
        { v: null }, //batchnumber
        //{ v: pricingBean.cost },
        //{ v: null }, //newcost
        { v: pricingBean.unitType },
        { v: null }, //quantity
        {
          info: {
            productBean: productBean,
          },
        },
      ];
      data.push(item);
      setItems(data);
    } else {
      props.showMessage("warning", translate("Product alredy exists"));
    }
  }

  function getItemIndex(productId, itemList) {
    console.log();
    let index = null;
    // console.log("itemList", itemList);
    // console.log("productId", productId);
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i][5].info.productBean.id == productId) {
        index = i;
        break;
      }
    }
    console.log("itemList", itemList);
    return index;
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];
    // let barcodeToRemove = data[tableMeta.rowIndex][5].info.barcode;
    data.splice(tableMeta.rowIndex, 1);
    if (tableMeta.rowIndex != tableMeta.tableData.length - 1) {
      for (let i = tableMeta.rowIndex; i < data.length; i++) {
        data[i][0].v = data[i][0].v - 1;
      }
    }
    setItems(data);
    // if (barcodeToRemove != null)
    //   db.table("inventoryAdjBulkImport").delete(barcodeToRemove);
  }

  function validate() {
    let flag = true;
    if (!description || description === "") {
      setDescriptionError(translate("Note is required"));
      flag = false;
    }
    if (!productionNumber || productionNumber === "") {
      setproductionNumberError(translate("Production Number is required"));
      flag = false;
    }
    if (!productionDate || productionDate === "") {
      setProductionDateError(translate("Production Date is required"));
      flag = false;
    }
    if (items.length < 1) {
      props.showMessage(
        "error",
        translate("Please add products before proceed")
      );
      flag = false;
    }
    for (let i = 0; i < items.length; i++) {
      console.log("items", items);
      if (
        items[i][2].v == null ||
        items[i][2].v == undefined ||
        items[i][2].v === ""
      ) {
        props.showMessage("error", "Batch Number is wrong at row: " + (i + 1));
        return false;
      }
      /*if (
        items[i][4].v == null ||
        items[i][4].v == undefined ||
        items[i][4].v === ""
      ) {
        props.showMessage("error", "New Cost is wrong at row: " + (i + 1));
        return false;
      }*/
      if (
        items[i][4].v == null ||
        items[i][4].v == undefined ||
        items[i][4].v === ""
      ) {
        props.showMessage("error", "Quantity is wrong at row: " + (i + 1));
        return false;
      }
    }
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function resetFields() {
    setProductionDateError("");
    setProductionDate("");
    setproductionNumberError("");
    setDescriptionError("");
    setProductionNumber("");
    setDescription("");
    setItems([]);
  }

  useEffect(() => {
    if (liveValidation && description === "")
      setDescriptionError(translate("Note is Required"));
    else setDescriptionError("");
  }, [description]);

  useEffect(() => {
    if (liveValidation && productionNumber === "")
      setproductionNumberError(translate("Production Number is Required"));
    else setproductionNumberError("");
  }, [productionNumber]);

  useEffect(() => {
    if (liveValidation && productionDate === "")
      setProductionDateError(translate("Production Number is Required"));
    else setProductionDateError("");
  }, [productionDate]);

  async function onSave() {
    if (validate()) {
      setConfirmOpen(true);
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to proceed, This action can not be undone!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
        action: "save",
      });
    }
  }
  async function handleSaveDraftClicked() {
    if (validate()) {
      saveData("DRAFT");
    }
  }

  async function onYesNoClicked(context, value) {
    let action = context.action;
    setConfirmOpen(false);

    if (value == "yes" && action === "save") {
      saveData("POSTED");
    }

    if (value == "yes" && action === "delete") {
      try {
        let result = await API.delete("/api/v1/production/" + origObject.id);
        props.showMessage(
          "warning",
          translate("order Id") +
            " " +
            origObject.productionNumber +
            " " +
            translate("got Removed")
        );

        props.onRefreshList();
        props.setOpenWindow(false);
      } catch (err) {
        console.log(err);
        props.showMessage("error", translate("Not able to Delete order"));
      }
    }
  }

  function createPayload(status) {
    try {
      let payload = [];
      let itemsTemp = [...items];

      let batch = itemsTemp.splice(0); //lastIndex
      let saveObject = Object.create(null);

      saveObject["status"] = status;
      saveObject["description"] = description;
      saveObject["productionNumber"] = productionNumber;
      saveObject["productionDate"] = productionDate;

      let selectedItems = [];
      batch.map((value) => {
        let itemsObject = Object.create(null);
        itemsObject["productName"] = value[1].v;
        itemsObject["batchNumber"] = value[2].v;
        //itemsObject["newCost"] = value[4].v;
        itemsObject["quantity"] = value[4].v;
        itemsObject["productId"] = value[5].info.productBean.id;
        itemsObject["unitType"] = value[3].v;
        selectedItems.push(itemsObject);
      });
      saveObject["productionItems"] = selectedItems;
      // }

      if (origObject) {
        saveObject["id"] = origObject.id;
        saveObject["intVersion"] = origObject.intVersion;
      } else {
        saveObject["id"] = null;
        saveObject["intVersion"] = 0;
      }

      console.log("payload", saveObject);
      return saveObject;
    } catch (error) {
      console.log("ERROR", error);
      return null;
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function saveData(status) {
    try {
      showProgress(true, "Saving");
      var payload = createPayload(status);
      let result = await API.post("/api/v1/production", payload);
      props.showMessage("success", translate("Data Saved successfully"));
      //SyncUtils.requestSync(result.headers);
      if (props.from === "dashboard") {
        resetFields();
        onCloseWindow();
      } else {
        resetFields();
        onCloseWindow();
        props.onRefreshList();
      }
      showProgress(false, "Saving");
    } catch (err) {
      showProgress(false, "Saving");
      props.showMessage("error", translate("Someting went wrong while save"));
      console.log("ERROR", err);
    }
  }

  function updateData(eventSource, meta, value, index) {
    if (eventSource === "table") {
      var data = [...items];
      data[meta.rowIndex][meta.columnIndex] = value;
      setItems(data);
    }
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete Production Number") +
        " :" +
        origObject.productionNumber +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      action: "delete",
    });
  }
  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "true",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 400,
    rowsPerPage: Math.round((getWindowDimensions().height - 400) / 50),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 400) / 50),
      15,
      50,
      100,
    ],
  };

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 255 }}>{value.v}</div>
        ),
      },
    },

    {
      name: "batchnumber",
      label: translate("Batch Number"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="text"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },

    // {
    //   name: "newCost",
    //   label: translate("New Cost"),
    //   options: {
    //     filter: false,
    //     sort: false,
    //     display: "true",

    //     customBodyRender: (value, tableMeta, updateValue) => (
    //       <div style={{ width: 70 }}>
    //         <PText
    //           value={value.v}
    //           type="number"
    //           onChange={(e) =>
    //             updateData(
    //               "table",
    //               tableMeta,
    //               e.target.value
    //                 ? { v: e.target.value, e: "" }
    //                 : { v: "", e: "" }
    //             )
    //           }
    //         ></PText>
    //       </div>
    //     ),
    //   },
    // },
    {
      name: "unitType",
      label: translate("Unit Type"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "quantity",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: props.mode === "view" ? "false" : "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];
  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <table width="75%">
          <tbody>
            <tr>
              <td width="40%">{translate("Production No")}</td>
              <td>
                <PText
                  value={productionNumber}
                  error={productionNumberError}
                  onChange={(e) => {
                    setProductionNumber(e.target.value);
                  }}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="15%">{translate("Note")}</td>
              <td>
                <PText
                  value={description}
                  error={descriptionError}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setDescriptionError(null);
                  }}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="75%">
          <tbody>
            <tr>
              <td width="40%">{translate("Production Date")}</td>
              <td>
                <PDatePicker
                  value={productionDate}
                  type="date"
                  error={productionDateError}
                  onChange={(e) => {
                    let d = new Date();
                    e.$d.setHours(d.getHours());
                    e.$d.setMinutes(d.getMinutes());
                    e.$d.setSeconds(d.getSeconds());
                    setProductionDate(e.$d.toISOString());
                  }}
                ></PDatePicker>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={12}>
        <table width="100%">
          <tr>
            <td width="100%">
              <AsyncSelect
                formatOptionLabel={formatOptionLabel}
                components={{ formatOptionLabel }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  marginRight: "10px",
                }}
                placeholder={translate("Product Lookup")}
                loadOptions={getOptions}
                onChange={productLookupChanged}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                }}
                value={prodLookupValue}
              />
            </td>
          </tr>
        </table>
      </Grid>
      <Grid item xs={12} sm={12}>
        <MUIDataTable data={items} columns={columns} options={options} />
      </Grid>
    </Grid>
  );

  return (
    <div>
      <PDialog
        content={content}
        open={true}
        title={windowTitle}
        maxWidth={"lg"}
        fullWidth={true}
        onCloseWindow={onCloseWindow}
        onSave={onSave}
        onSaveDraftClicked={handleSaveDraftClicked}
        // showSaveDraftButton={props.mode === "view" ? false : true}
        showSaveDraftButton={
          (!props.context.privileges.manufacturing_edit &&
            props.context.privileges.manufacturing_delete) ||
          props.mode == "view"
            ? props.mode === "create"
              ? true
              : false
            : true
        }
        saveLabel="POST"
        onDelete={
          props.context.privileges.manufacturing_delete ? onDelete : false
        }
        mode={props.mode}
        hideSave={
          (!props.context.privileges.manufacturing_edit &&
            props.context.privileges.manufacturing_delete) ||
          props.mode === "view"
            ? props.mode === "create"
              ? false
              : true
            : false
        }
      ></PDialog>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}

{showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
